
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import config from '@/config/index'
import { getExam, getview, addAddress2, addPartyCount } from '@/api/jfhl.js'
import {
getAddressDefault,
addAddress,
operateCreditlist,
editAddress
} from '@/api/user.js'
import { getaddlog } from '@/api/hgfw'
export default {
directives: {
TransferDom
},
components: {
XButton
},
data() {
return {
baseUrl: config.baseUrl,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: ''
},
explist: [],
addressValue: [],
addresslist: [],
partyid: this.$route.params.partyid,
provinceid: '',
cityid: '',
countyid: '',
isAddress: true,
startTime: '',
endTime: '',
isclick: false,
num: 0,
isGo: true,
partyuserid: '',
addressid: ''
}
},
computed: {
accountid() {
return this.$store.state.user.accountid
},
userid() {
return this.$store.state.user.userid
}
},
mounted() {
this.view()

this.getAdd()
this.addcount()
this.getdefault()
},
watch: {
addressValue: {
handler: function(val) {
this.provinceid = val[0]
this.cityid = val[1]
this.countyid = val[2]
},
deep: true
}
},
methods: {

isCurrentTime(beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.start = 1
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '答题活动还未开始'
})
this.isclick = true
return false
}
if (currentTime >= endTime) {
this.start = 1
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '答题活动已结束'
})
this.isclick = true
return false
}
this.isclick = false
this.getExam()
},

getAdd() {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120105
}).then(res => {})
},

addcount() {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {})
},

addIntegral() {
operateCreditlist({
accountid: this.accountid,
rulecode: 'party_rule',
credit: 2,
owner_type: '2007',
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => {})
},

view() {
getview({
id: this.partyid
}).then(res => {
this.explist = res.obj.explist
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
})
},

sumbit() {




















addAddress2({
userid: this.accountid,
partyid: this.partyid,



provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid
}).then(res => {
if (res.success) {
this.partyuserid = res.obj.partyuserid





this.$router.push({
name: 'nvzhigongquanyiAnswer',
params: { partyid: this.partyid, partyuserid: this.partyuserid }
})
}
})
},
address() {
addAddress({
accountid: this.accountid,
openid: this.userid,
address: this.personObj.ADDRESS,
isdefault: 1,
provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE
}).then(res => {})
},
edit() {
editAddress({
addressid: this.addressid,
accountid: this.accountid,
openid: this.userid,
address: this.personObj.ADDRESS,
isdefault: 1,
provinceid: this.provinceid,
cityid: this.cityid,
countyid: this.countyid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE
}).then(res => {})
},

getExam() {
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
})
.then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.isGo = false
this.isclick = true
this.num = 0
this.$vux.toast.text('您今天的答题机会已用完请明天再来')
return false
} else {
this.num = data.obj.ANSWERNUM
this.isGo = true
this.isclick = false
}
})
.catch(data => {
this.isclick = true
})
},
getdefault() {
getAddressDefault({
userid: this.userid,
accountid: this.accountid
}).then(data => {
if (data.returnValue !== '') {
this.isAddress = true
this.addressid = data.returnValue.ID
this.personObj.NAME = data.returnValue.NAME
this.personObj.MOBILE = data.returnValue.MOBILE
this.$set(
this.addressValue,
0,
data.returnValue.PROVINCEID.toString()
)
this.$set(this.addressValue, 1, data.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, data.returnValue.COUNTYID.toString())
this.personObj.ADDRESS = data.returnValue.ADDRESS
} else {
this.isAddress = false
}
})
},
gorule() {
this.$router.push({ name: 'nvzhigongquanyiRule' })
}
}
}
